import { IconCloudRain, IconDropletDown, IconWaveSine, type Icon } from "@tabler/icons-react";

export interface CalculatorInfo {
  path: string;
  name: string;
  short: string;
  icon: Icon;
  color: string;
  summary: string;
}

/** The three calculators, as presented in the navigation and on the home page. */
export const CALCULATORS: CalculatorInfo[] = [
  {
    path: "/rainfall",
    name: "Rainfall Analysis",
    short: "Rainfall",
    icon: IconCloudRain,
    color: "blue",
    summary:
      "Separates a hyetograph into storm events (12-hour inter-event period) and reports total depth, duration, average and peak 5-, 10- and 60-minute intensities, and antecedent dry periods.",
  },
  {
    path: "/flow",
    name: "Flow Analysis",
    short: "Flow",
    icon: IconWaveSine,
    color: "basin",
    summary:
      "Computes runoff volume, runoff duration and peak flow rate for inflow, outflow and bypass hydrographs of a single event, over a period you choose.",
  },
  {
    path: "/infiltration",
    name: "Infiltration Analysis",
    short: "Infiltration",
    icon: IconDropletDown,
    color: "teal",
    summary:
      "Fits an exponential decay to the recession limb of ponded water depth and reports the infiltration rate for each sensor and event, with QA/QC flags.",
  },
];
